<template>
    <div class="image-item" :class="[
        type,
        size,
        {
            selected,
            active,
        }
    ]">
        <!-- 占位图 -->
        <div class="placeholder" v-if="!imageLoaded">
            <img src="@/assets/logo.png" class="logo" />
            <span class="text">AIdeer</span>
        </div>

        <!-- 实际图片 -->
        <img v-if="image.OriginUrl" class="image" :src="getCompressedUrl(image.OriginUrl)" @load="handleImageLoad"
            @error="handleImageError" alt="" />

        <!-- 选中标记（待选列表） -->
        <div v-if="type === 'source' && selected" class="selected-mark">
            <CheckOutlined />
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { CheckOutlined } from '@ant-design/icons-vue';
import { setCompressParam } from '@/utils';

const props = defineProps({
    image: {
        type: Object,
        required: true,
    },
    type: {
        type: String,
        default: 'source', // 'source' | 'edit'
    },
    size: {
        type: String,
        default: 'medium', // 'small' | 'medium'
    },
    selected: {
        type: Boolean,
        default: false,
    },
    active: {
        type: Boolean,
        default: false,
    },
});

const imageLoaded = ref(false);

const getCompressedUrl = (url) => {
    // 图片服务器最小只支持 mini-168
    const style = 'mini-168';
    return setCompressParam(url, `x-image-process=style/${style}`);
};

const handleImageLoad = () => {
    imageLoaded.value = true;
};
// 添加监听
watch(() => props.image, (newVal) => {
    console.log('ImageItem received:', {
        requestId: newVal.requestId,
        OriginUrl: newVal.OriginUrl,
        hasUrl: !!newVal.OriginUrl
    });
}, { immediate: true });

const handleImageError = () => {
    console.error('Image load error:', props.image.requestId);
};
</script>

<style lang="less" scoped>
.image-item {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    border: 2px solid transparent;
    transition: all 0.2s;
    cursor: pointer;
    margin-bottom: 4px;

    // 尺寸
    &.small {
        width: 80px;
        height: 80px;
    }

    &.medium {
        width: 144px;
        height: 108px;
    }

    // 类型样式
    &.source {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

        &:hover {
            border-color: #2B8CFF;
            transform: scale(1.02);
        }

        &.selected {
            opacity: 0.6;
            border-color: #52c41a;
        }
    }

    &.edit {
        // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &:hover {
            transform: translateY(-2px);
            // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        &.active {
            border-color: #2B8CFF;
            // box-shadow: 0 4px 12px rgba(43, 140, 255, 0.3);
        }
    }
}

.placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 1;

    .logo {
        width: 40px;
        opacity: 0.3;
        margin-bottom: 4px;
    }

    .text {
        display: block;
        font-size: 11px;
        color: #999;
    }
}

.image {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 2;
}

.selected-mark {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
    background: #52c41a;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 12px;
    font-weight: bold;
    z-index: 10;
}
</style>
